import Modal from 'styled-react-modal'

const StyledModal = Modal.styled(({ theme }) => ({
  backgroundColor: theme.colors.grayscale.white,
  borderRadius: '8px',
  display: 'flex',
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: '100%',
  flexDirection: 'column',
  height: 'fit-content',
  maxHeight: '90%',
  maxWidth: '416px',
  overflowX: 'hidden',
  overflowY: 'auto',
  paddingBottom: '30px',
}))

export default StyledModal
